import React, { useEffect, useState } from 'react';
import { Grid, GridCellProps, GridRowProps, GridColumn as Column, GridItemChangeEvent, GridNoRecords } from "@progress/kendo-react-grid";
import { Icon } from '@iconify/react';
import * as Utils from '../../../../utils/EllowUtils'
import Styles from "../../styles.module.scss"
import SideMenu from "../../sideMenu";
import DashboardHeader from "../../dashboardHeader"
import * as CONSTANTS from '../../../../utils/CONSTANTS';
import { getMilliSecUTC, makeSideBarActive , convertMilliSecToDateNew } from '../../../../utils/EllowUtils';
import Headline6 from "../../../../components/headings/Headline6";
import Button from "../../../../components/button";
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import TimeSheetSubmit from '../../../../modals/timesheetSubmit';
import { useLocation } from 'react-router-dom';
import { extractTimesheetDownload, timesheetDetails, updateTimeSheet, getHistory } from './services';
import NotificationAlert from '../../../../components/notification';
import Table from '../../../../components/tables/checkHistory';
import { Error } from "@progress/kendo-react-labels";
import Fields from "../../../../components/field/freeField";
import classnames from "classnames";
import Headline5 from '../../../../components/headings/Headline5';
import { REACT_APP_CANDIDATE_FREELANCER } from '../../../../utils/common';
import { postAPI } from '../../../../api/apis';
import mixpanelData from '../../../../utils/mixpanel';


interface Product {
  workHoursCount: string;
  dayStatus: string;
  entryDate: string,
  entryDay: string,
}

interface Props {
  OnSubmit?: any,
  loginId?: string | null,
  // defaultValues?: { availability: {availabilityId: number | undefined, entryDate: string}, contractType: number | undefined, workType: number | undefined, jobSearchCriteria: number | undefined},
}

interface CellRenderProps {
  originalProps: GridCellProps;
  td: React.ReactElement<HTMLTableCellElement>;
  enterEdit: (dataItem: Product, field: string | undefined) => void;
  editField: string | undefined;
}

interface RowRenderProps {
  originalProps: GridRowProps;
  tr: React.ReactElement<HTMLTableRowElement>;
  exitEdit: () => void;
  editField: string | undefined;
}

export const CellRender = (props: CellRenderProps) => {
  const dataItem = props.originalProps.dataItem;
  const cellField = props.originalProps.field;
  const inEditField = dataItem[props.editField || ""];
  const additionalProps = cellField && cellField === inEditField ? {
    ref: (td: any) => {
      const input = td && td.querySelector("input");
      const activeElement = document.activeElement;

      if (
        !input ||
        !activeElement ||
        input === activeElement ||
        !activeElement.contains(input)
      ) {
        return;
      }

      if (input.type === "checkbox") {
        input.focus();
      } else {
        input.select();
      }
    }
  }
    : {
      onClick: () => {
        props.enterEdit(dataItem, cellField);
      }
    };

  const clonedProps: any = { ...props.td.props, ...additionalProps };
  return React.cloneElement(props.td, clonedProps);
}

export const RowRender = (props: RowRenderProps) => {
  const weekdays = props.originalProps.dataItem.entryDay === 'Saturday' || props.originalProps.dataItem.entryDay === 'Sunday'
  const green = "holiday";
  const red = "weekday";
  const trProps: any = { className: weekdays ? green : red };
  return React.cloneElement(props.tr, { ...trProps });
}


const Avilability: React.FC<Props> = () => {

  const { v4: uuidv4 } = require("uuid")
  const menu = makeSideBarActive(CONSTANTS.sideMenuFreelancer, 1)
  const loginId = localStorage.getItem('loginId')
  const employeeId = localStorage.getItem('employee_id')
  // const profileMetadata = JSON.parse(localStorage.getItem("profile_metadata") || "") || {}
  const value: any = useLocation().state
  const candidate_data: any = value && value.state
  const profileData: any = value && value.candidate_data
 
  const EDIT_FIELD = "inEdit";

  const [name, setName] = useState<string>('')
  // const [warningMessage, setWarningMessage] = useState<boolean>(true)
  const [projectId, setProjectId] = useState<string>('')
  const [timeSheetId, setTimeSheetId] = useState<string>('')
  const [tablearray, setTableArray] = useState<Array<Product>>([])
  const [startDate, setStartDate] = useState<any>()
  const [endDate, setEndDate] = useState<any>()
  const [data, setData] = React.useState<Array<Product>>(tablearray);
  // const [changes, setChanges] = React.useState<boolean>(false);
  const [showSubmitModal, setShowSubmitModal] = useState<boolean>(false)
  const [sheetDetails, setSheetDetails] = useState<any>()
  const [projectDetails, setProjectDetails] = useState<any>()
  const [modalData, setModalData] = useState<any>()
  const [notification, setNotification] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [candidateData, setCandidateData] = useState<{ timesheet_id: string, project_id: string, candidate_name: string, company_name: string, project_name: string, designation: string, start_date: string, end_date: string }>({ timesheet_id: '', project_id: '', candidate_name: '', company_name: '', project_name: '', designation: '', start_date: '', end_date: '' })
  const [checkHistoryData, setCheckHistoryData] = useState<any>()
  const [error, setError] = useState<string>('');
  const [overTime, setOvertime] = useState<string>('');
  const [submitButton, setSubmitButton] = useState<boolean>(false)
  const [modalSubmitButton, setModalSubmitButton] = useState<boolean>(false)
  const [candidateType, setCandidateType] = useState<string>('')
  const [leaveAllowed, setLeaveAllowed] = useState<boolean>(false)
  const [rejectComment, setRejectComment] = useState<string>('')
  const today = getMilliSecUTC(new Date());


  const enterEdit = (dataItem: Product, field: string | undefined) => {

    if (getMilliSecUTC(dataItem.entryDate) <= today) {
      const newData = data.map((item) => ({
        ...item,
        [EDIT_FIELD]: item.entryDate === dataItem.entryDate ? field : ''
      }));
      setData(newData);
    }
  };

  useEffect(() => {

    if (value && value.state) {
      setProjectId(value.state.projectId)
      setTimeSheetId(value.state.timesheetId)
      getSheetDetails(value.state.timesheetId, value.state.projectId)
      getHistoryDetails(value.state.timesheetId)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value && value.state])

  const getHistoryDetails = (timesheetId: string) => {
    getHistory(timesheetId).then((response) => {
      if (response && response.status === 1) {
        setCheckHistoryData(response.data)
      }
    })
  }

  const getSheetDetails = (timeSheetId: string, projectId: string) => {
    timesheetDetails(timeSheetId, projectId).then((response) => {
      if (response && response.status === 1) {
        setSheetDetails(response.data[0].timesheetDetails[0])
        setProjectDetails(response.data[0].projectDetails[0])
        setLeaveAllowed(response.data[0] && response.data[0].projectDetails[0] && response.data[0].projectDetails[0].paymentSettings && response.data[0].projectDetails[0].paymentSettings.companyPaidLeaveAllowed)
        getDaysArray(parseInt(response.data[0].timesheetDetails[0].start_date), parseInt(response.data[0].timesheetDetails[0].end_date))
        setCandidateData(response.data[0].timesheetDetails[0])
        setCandidateType(response.data[0] && response.data[0].projectDetails[0] && response.data[0].projectDetails[0].paymentSettings && response.data[0].projectDetails[0].paymentSettings.billingType)
        setOvertime(response.data[0].overtime)
        setRejectComment(response.data[0].timesheetDetails[0].reject_comment)
        let values = {
          reportingManager: response.data[0] && response.data[0].projectDetails[0] && response.data[0].projectDetails[0].reportingManagerName,
          reportingManagerEmail: response.data[0] && response.data[0].projectDetails[0] && response.data[0].projectDetails[0].reportingManagerEmail,
          payPeriod: {
            "startDate": parseInt(response.data[0].timesheetDetails[0].start_date),
            "endDate": parseInt(response.data[0].timesheetDetails[0].end_date),
          }
        }
        setModalData(values)
        setStartDate(parseInt(response.data[0].timesheetDetails[0].start_date))
        setEndDate(parseInt(response.data[0].timesheetDetails[0].end_date))
        if (response.data[0].timesheetEntries && response.data[0].timesheetEntries.length > 0) {
          let entries = response.data[0].timesheetEntries && response.data[0].timesheetEntries.map((item: any) => {
            return (
              {
                entryDate: new Date(parseInt(item.entry_date)).toDateString().slice(3),
                entryDay: item.entry_day,
                workHoursCount: item.workhours_count,
                workDescription: item.work_description,
                dayStatus: item.day_status,
                timesheetEntryId: item.timesheet_entry_id
              }
            )
          })
          setData(entries)
        }
      }
    })
  }

  const exitEdit = () => {
    const newData = data.map((item) => ({ ...item, [EDIT_FIELD]: undefined }));
    setData(newData);
  }

  const saveChanges = (value: any, name: string) => {

    if (name === 'submit') {
      setSubmitButton(true)
      setModalSubmitButton(true)
    }
    let emails = value && value.emailIds && value.emailIds.split(',')
    tablearray.splice(0, tablearray.length, ...data);
    // setChanges(false);
    let timeSheetEntry: any = tablearray && tablearray.map((item: any) => {
      return (
        {
          "timesheetEntryId": item.timesheetEntryId ? item.timesheetEntryId : uuidv4(),
          "entryDay": item.entryDay,
          "entryDate": Utils.getMilliSecUTC(item.entryDate),
          "workHoursCount": item.workHoursCount ? parseInt(item.workHoursCount) : 0,
          "workDescription": item.workDescription ? item.workDescription : '',
          "dayStatus": item.dayStatus ? item.dayStatus : '',
        }
      )
    })   
    let body = {
      "action": name,
      "submittedBy": "FREELANCER",
      "loginId": loginId,
      "candidateName": candidate_data.candidateName,
      "projectName": projectDetails.projectName,
      "companyName": projectDetails.companyName,
      "timesheetId": timeSheetId,
      "projectId": projectId,
      "jobRole": candidate_data.position,
      "startDate": parseInt(candidateData && candidateData.start_date),
      "endDate": parseInt(candidateData && candidateData.end_date),
      "totalWorkingDays": checkTotalWorkingDays(),
      "actualWorkingDays": findActualCount(data.filter(element => (element.dayStatus !== 'Weekend' && element.dayStatus !== 'Holiday' && element.dayStatus !== 'Full day leave'))),
      "actualWorkingHours": calcTotalworkingHours(data.filter(element => (element.dayStatus !== 'Weekend' && element.dayStatus !== 'Holiday' && element.dayStatus !== 'Full day leave' && element.dayStatus !== 'Compensation off'))),
      "holidays": leaveAllowed ? data.filter(element => (element.dayStatus === 'Holiday')).length : sheetDetails && sheetDetails.month_holidays,
      "compOff": data.filter(element => (element.dayStatus === 'Compensation off')).length,
      "HalfDaycompOff": data.filter(element => (element.dayStatus === 'Half day compensation off')).length,
      "leaves": checkLeaves(data.filter(element => (element.dayStatus !== 'Weekend' && element.dayStatus !== 'Compensation off'))),
      "timesheetEntries": timeSheetEntry,
      "overtime": overTime ? parseFloat(overTime) : 0,
      "submittedTo": emails,
      "reportingManagerName": projectDetails.reportingManagerName,
      "reportingManagerEmail": projectDetails.reportingManagerEmail
    }
    if(emails === ''){
      delete body.submittedTo
    }
    if (candidateType === 'Type1' && (body.actualWorkingHours > body.actualWorkingDays * 8)) {
      setMessage("Your working hours are exceeding the total working hours available for the specified duration")
      setNotification(true)
      setTimeout(() => {
        setNotification(false)
        updateTimesheetDetails(body)
      }, 4000);
    }
    else if (candidateType === 'Type2' && body.actualWorkingHours > 160) {
      setMessage("Your working hours are exceeding the total working hours available for the specified duration")
      setNotification(true)
      setTimeout(() => {
        setNotification(false)
        updateTimesheetDetails(body)
      }, 4000);
    }
    else {
      updateTimesheetDetails(body)

    }
  }

  const updateTimesheetDetails = (body: any) => {
    updateTimeSheet(body).then((response) => {
      if (response && response.status == 1) { 
        mixpanelData(`New MWP - Timesheet ${rejectComment !== null ? 'Re-Submitted' : body.action === 'save' ? 'saved': 'submitted'}`, {
          // 'source': `Recruiter ${body.action === 'save' ? 'saves': 'submits'} timesheet` ,
          'distinct_id': localStorage.getItem('Email'),
          'Candidate email': localStorage.getItem('Email'),
          'Candidate name' : body.candidateName,
          'Company name': body.companyName,
          'Position name': candidate_data.position,
          'Pay period start date': convertMilliSecToDateNew(body.startDate),
          'Pay period end date': convertMilliSecToDateNew(body.endDate),
          'Status': body.action === 'save' ? 'drafts' : 'submitted',
          'Project name': body.projectName,
          'Reporting manger email': body.reportingManagerEmail,
          'Additional emails': body.submittedTo,
          'Total days': body.totalWorkingDays,
          'Actual working days': body.actualWorkingDays,
          'Holidays': body.holidays,
          'Leaves': body.leaves,
          'Overtime': body.overtime,
          'Actual working hours': body.actualWorkingHours,
          'Candidate loginid' : loginId 
        })
        setShowSubmitModal(false)
        displayNotification(name === 'save' ? "Timesheet saved successfully" : "Timesheet submitted successfully")
        let value = {
          timesheet_id: timeSheetId
        }
        extractTimesheetDownload(value)
      }
    })
  }

  const itemChange = (event: GridItemChangeEvent) => {
    setError('')
    let field = event.field || "";
    event.dataItem[field] = event.value;
    let newData = data.map((item) => {
      if (item.entryDate === event.dataItem.entryDate) {
      }
      return item
    })
    setData(newData)
    // setChanges(true)
  }

  const customCellRender: any = (
    td: React.ReactElement<HTMLTableCellElement>,
    props: GridCellProps
  ) => (
    <CellRender
      originalProps={props}
      td={td}
      enterEdit={enterEdit}
      editField={EDIT_FIELD}
    />
  )

  const customRowRender: any = (tr: React.ReactElement<HTMLTableRowElement>, props: GridRowProps) => (
    <RowRender
      originalProps={props}
      tr={tr}
      exitEdit={exitEdit}
      editField={EDIT_FIELD}
    />
  )

  const days = ['Sunday', 'Monday', 'TuesDay', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

  // const dateChange = (e: any, name: string) => {
  //   if (name === 'startDate') {
  //     setStartDate(Utils.getMilliSecUTC(e.target.value))
  //   } else {
  //     setEndDate(Utils.getMilliSecUTC(e.target.value))
  //   }
  //   calcDiff();
  //   getDaysArray(startDate, endDate)
  // }

  const checkDate = (value: string) => {
    switch (value) {
      case 'Saturday':
        return 'Weekend'
      case 'Sunday':
        return 'Weekend'
      default:
        return ''
    }
  }

  var getDaysArray = function (start: any, end: any) {
    for (var arr = [], dt = new Date(start); dt <= new Date(end); dt.setDate(dt.getDate() + 1)) {
      arr.push({ 'entryDate': Utils.convertMilliSecToDateNew(dt), 'entryDay': days[dt.getDay()], 'dayStatus': checkDate(days[dt.getDay()]), 'workHoursCount': '' });
    }
    setData(arr)
    setTableArray(arr)
    return arr
  }

  const calcTotalworkingHours = (data: any) => {
    let hours = 0
    data && data.map((item: any) => {
      hours = hours + Number(item.workHoursCount)
    })
    return hours
  }

  const monthNumber = new Date(startDate).getMonth()
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  let presentMonth = months[monthNumber]

  const displayNotification = (message: string) => {
    setMessage(message)
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
      // setWarningMessage(false)
    }, 4000);
  }

  const saveTimesheet = () => {
    // let today = new Date().toDateString()
    // let array = data
    // let length = data.length
    let validData = data && data.filter(element => (element.entryDay !== 'Saturday' && element.entryDay !== 'Sunday' && element.dayStatus !== 'Holiday' && element.dayStatus !== 'Full day leave' && element.dayStatus !== 'Compensation off'))
    let check: any = validData && validData.length > 0 && validData.map((item: any) => {
      return (
        (item.workHoursCount !== '0' && item.workHoursCount !== '' && item.dayStatus !== '') ?
          true : false
      )
    })

    if (check.includes(false)) {
      setError('Complete the timesheet before submitting')
      setShowSubmitModal(false)
    }
    else {
      setShowSubmitModal(true);
      setName('submit')
      let calculations = {
        totalWorkingDays: checkTotalWorkingDays(),
        actualWorkingDays: findActualCount(data.filter(element => (element.dayStatus !== 'Weekend' && element.dayStatus !== 'Holiday' && element.dayStatus !== 'Full day leave'))),
        actualWorkingHours: calcTotalworkingHours(data.filter(element => (element.dayStatus !== 'Weekend' && element.dayStatus !== 'Holiday' && element.dayStatus !== 'Full day leave' && element.dayStatus !== 'Compensation off'))),
        holidays: leaveAllowed ? data.filter(element => (element.dayStatus === 'Holiday')).length : sheetDetails && sheetDetails.month_holidays,
        compOff: data.filter(element => (element.dayStatus === 'Compensation off')).length,
        HalfDaycompOff: data.filter(element => (element.dayStatus === 'Half day compensation off')).length,
        leaves: checkLeaves(data.filter(element => (element.dayStatus !== 'Weekend' && element.dayStatus !== 'Compensation off'))),
        overtime: overTime,
      }
      setModalData({ ...modalData, calculations })
    }
  }

  const findActualCount = (data: any) => {
    let count = 0
    data && data.map((item: any, key: number) => {
      if (item.dayStatus === 'Half day leave') {
        if (item.workHoursCount >= 4) {
          count = count + 0.5
        }
      } else if (item.dayStatus === 'Compensation off') {
        count = count + 1
      } else if (item.dayStatus === 'Half day compensation off') {
        if (item.workHoursCount >= 8) {
          count = count + 1
        } else if (item.workHoursCount < 8 && item.workHoursCount >= 4) {
          count = count + 1
        } else if (item.workHoursCount <= 4) {
          count = count + 0.5
        }
      } else if (leaveAllowed) {
        if (item.dayStatus === 'Working') {
          if (item.workHoursCount >= 8) {
            count = count + 1
          } else if (item.workHoursCount <= 8 && item.workHoursCount >= 4) {
            count = count + 0.5
          } else if (item.workHoursCount <= 4) {
            count = count + 0
          }
        }
      } else if (!leaveAllowed) {
        if (item.dayStatus === 'Working') {
          if (item.workHoursCount >= 8) {
            count = count + 1
          } else if (item.workHoursCount <= 8 && item.workHoursCount >= 4) {
            count = count + 0.5
          } else if (item.workHoursCount <= 4) {
            count = count + 0
          }
        }
      }
    })
    return count
  }

  const checkLeaves = (data: any) => {


    let count = 0
    data && data.map((item: any, key: number) => {
      if (leaveAllowed) {

        if (item.dayStatus === 'Half day leave') {
          if (item.workHoursCount < 4 && item.workHoursCount > 0) {
            count = count + 1
          } else {
            count = count + 0.5
          }
        } else if (item.dayStatus === 'Half day compensation off') {
          if (item.workHoursCount < 4 && item.workHoursCount >= 0) {
            count = count + 0.5
          } else {
            count = count + 0
          }
        } else if (item.dayStatus === 'Full day leave') {
          count = count + 1
        } else if (item.dayStatus === 'Holiday') {
          count = count + 0
        }
        else if (item.workHoursCount >= 8) {
          count = count + 0
        } else if (item.workHoursCount <= 8 && item.workHoursCount >= 4) {
          count = count + 0.5
        } else if (item.workHoursCount <= 4 && item.workHoursCount > 0) {
          count = count + 0
        }
      } else {
        if (item.dayStatus === 'Half day leave') {
          if (item.workHoursCount < 4 && item.workHoursCount > 0) {
            count = count + 1
          } else {
            count = count + 0.5
          }
        } else if (item.dayStatus === 'Half day compensation off') {
          if (item.workHoursCount < 4 && item.workHoursCount >= 0) {
            count = count + 0.5
          } else {
            count = count + 0
          }
        } else if (item.dayStatus === 'Full day leave' || item.dayStatus === 'Holiday') {
          count = count + 1
        } else if (item.workHoursCount >= 8) {
          count = count
        } else if (item.workHoursCount <= 8 && item.workHoursCount >= 4) {
          count = count + 0.5
        } else if (item.workHoursCount <= 4 && item.workHoursCount > 0) {
          count = count + 1
        }
      }
    })
    return count
  }

  const checkStatus = (status: string) => {
    switch (status) {
      case '':
        return {
          value: 'Working',
          class: ' '
        }
      case 'Working':
        return {
          value: 'Working',
          class: ' '
        }
      case 'Weekend':
        return {
          value: 'Weekend',
          class: 'statusText Yellow'
        }
      case 'Holiday':
        return {
          value: 'Holiday',
          class: 'statusText Red'
        }
      default:
        return {
          value: status,
          class: 'statusText Red'
        }
    }
  }

  const dayStatusCell = (props: GridCellProps) => {
    return (
      <td>
        <div className={checkStatus(props.dataItem.dayStatus).class}>
          {checkStatus(props.dataItem.dayStatus).value}
        </div>
      </td>
    )
  }

  const downloadHandle = (url: any, name: string, projectName: string, startDate: number) => {
    const monthNumber = new Date(startDate).getMonth()
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    let presentMonth = months[monthNumber]
    fetch(url).then(response => {
      response.blob().then(blob => {
        const fileURL = window.URL.createObjectURL(blob);
        let alink = document.createElement('a');
        alink.href = fileURL;
        alink.download = `${name}-${projectName}-${presentMonth}.pdf`;
        alink.click();
      })
    })
  }

  const downloadTimesheet = () => {
    let value = {
      "action": "getObject",
      "filename": `timesheetUploads/${timeSheetId}.pdf`,
      "bucketName": "ellow-prod-doc-upload",
    };

    postAPI(REACT_APP_CANDIDATE_FREELANCER + '/api/v1/mwp/resume-signed-url', value).then((data) => {
      let signedUrl = data.url;
      downloadHandle(signedUrl, candidate_data && candidate_data.candidateName, projectDetails && projectDetails.projectName, sheetDetails && sheetDetails.start_date && parseInt(sheetDetails.start_date))
    })
  }

  const checkTotalWorkingDays = () => {
    let d = new Date(parseInt(sheetDetails && sheetDetails.start_date))
    let y = d.getFullYear()
    let m = d.getMonth() + 1
    let days = new Date(y, m, 0).getDate();
    let sat = new Array();   //Declaring array for inserting Saturdays
    let sun = new Array();
    for (var i = 1; i <= days; i++) {    //looping through days in month
      var newDate = new Date(d.getFullYear(), d.getMonth(), i)
      if (newDate.getDay() == 0) {   //if Sunday
        sun.push(i);
      }
      if (newDate.getDay() == 6) {   //if Saturday
        sat.push(i);
      }
    }
    let addHolidays = data && data.filter((item: any) => item.dayStatus === 'Holiday' && item.entryDay !== 'Saturday' && item.entryDay !== 'Sunday').length
    let holidays = sheetDetails && sheetDetails.month_holidays ? sheetDetails && sheetDetails.month_holidays : 0
    let val = days - (sun.length + sat.length) - holidays
    return val
  }

  return (
    <div>
      <section className={Styles.dashboardWrapper}>
        <SideMenu menu={menu} />
        <div className={Styles.dashboardContent}>
          <DashboardHeader searchChange={''} title={value && value.state.timesheetStatus === '3' ? ['Timesheet'] : ['Create New']} timesheetStatus={candidate_data && candidate_data.timesheetStatus} />
          <div className="contentBox mb-40">
            <div className="innerPadd24">
              <div className={Styles.basicDetails}>
                <div className={Styles.basicHeadWrap}>
                  <Headline6>Basic Info</Headline6>
                  <button className={Styles.downloadButton} onClick={downloadTimesheet}><Icon icon="ic:outline-file-download" /></button>
                </div>
                <div className={Styles.basicInfoCard}>
                  <div className={Styles.cardItrem}>
                    <div className={Styles.form}>
                      <label>Customer:</label>
                      {projectDetails && projectDetails.companyName}
                    </div>
                    <div className={Styles.form}>
                      <label>Employee Email:</label>
                      {profileData && profileData.email}
                    </div>
                  </div>
                  <div className={Styles.cardItrem}>
                    <div className={Styles.form}>
                      <label>Employee Name:</label>
                      {candidate_data && candidate_data.candidateName}
                    </div>
                    <div className={Styles.form}>
                      <label>Reporting Manager:</label>
                      {projectDetails && projectDetails.reportingManagerName}
                    </div>
                  </div>
                  <div className={Styles.cardItrem}>
                    <div className={Styles.form}>
                      <label>Employee Phone:</label>
                      {profileData && profileData.phoneNumber}
                    </div>
                    <div className={Styles.form}>
                      <label>Reporting Manager Email:</label>
                      {projectDetails && projectDetails.reportingManagerEmail}
                    </div>
                  </div>
                  <div className={Styles.cardItrem}>
                    <div className={Styles.form}>
                      <label>Pay Period Start:</label>
                      {sheetDetails && sheetDetails.start_date && new Date(parseInt(sheetDetails.start_date)).toDateString()}
                    </div>
                    <div className={Styles.form}>
                      <label>Pay Period End: </label>
                      {sheetDetails && sheetDetails.end_date && new Date(parseInt(sheetDetails.end_date)).toDateString()}
                    </div>
                  </div>
                  <div className={Styles.cardItrem}>
                    <div className={Styles.form}>
                      <label>Project:</label>
                      {projectDetails && projectDetails.projectName}
                    </div>
                    <div className={Styles.form}>
                      <label>Employee Id:</label>
                      {employeeId}
                    </div>
                  </div>
                </div>
              </div>
              {sheetDetails && (!sheetDetails.submitted_on || sheetDetails.timesheet_status === '4' || sheetDetails.timesheet_status === '1') && <div className={Styles.tableHead}>
                <Headline6>{presentMonth}</Headline6>
                {/* <a href="#"><Icon icon="uil:file-import" />Import from Excel</a> */}
              </div>}
              <div className="tableStyle no-padd-top no-min-height">
                <Grid
                  data={data}
                  rowHeight={50}
                  onItemChange={itemChange}
                  cellRender={value && value.state.timesheetStatus !== '3' && customCellRender}
                  rowRender={customRowRender}
                  editField={value && value.state.timesheetStatus !== '3' && EDIT_FIELD}
                >
                  <GridNoRecords>
                    <div className="noData">
                      <Icon icon="mdi:smiley-neutral-outline" />
                      No data to display
                    </div>
                  </GridNoRecords>
                  <Column field="entryDate" title="Date" cell={(props: GridCellProps) => companyName(props)} editable={false} />
                  <Column field="entryDay" title="Day" editable={false} />
                  <Column field="workHoursCount" title="No.of working Hrs." editable={sheetDetails && sheetDetails.submitted_on && parseInt(sheetDetails.timesheet_status) > 1 && sheetDetails.timesheet_status !== '4' ? false : true} />
                  <Column field="workDescription" title="Work Description" editable={sheetDetails && sheetDetails.submitted_on && parseInt(sheetDetails.timesheet_status) > 1 && sheetDetails.timesheet_status !== '4' ? false : true} />
                  <Column field="dayStatus" title="status" editable={false} cell={sheetDetails && sheetDetails.submitted_on && parseInt(sheetDetails.timesheet_status) > 1 && sheetDetails.timesheet_status !== '4' ? dayStatusCell : (props: GridCellProps) => DropDown(props)} />
                </Grid>
              </div>
              <div className={Styles.totalInfo}>
                <div className={Styles.cardItremWrap}>
                  <div className={Styles.cardItrem}>
                    <div className={Styles.form}>
                      <label>Total working days in this month:</label>
                      {checkTotalWorkingDays()}
                    </div>
                    <div className={Styles.form}>
                      <label>Actual days worked:</label>
                      {findActualCount(data.filter(element => (element.dayStatus !== 'Weekend' && element.dayStatus !== 'Holiday' && element.dayStatus !== 'Full day leave')))}
                    </div>
                  </div>
                  <div className={Styles.cardItrem}>
                    <div className={Styles.form}>
                      <label>Holidays</label>
                      {leaveAllowed ? data.filter(element => (element.dayStatus === 'Holiday')).length : sheetDetails && sheetDetails.month_holidays}
                    </div>
                    <div className={Styles.form}>
                      <label>Leaves: </label>
                      {checkLeaves(data.filter(element => (element.dayStatus !== 'Weekend' && element.dayStatus !== 'Compensation off')))}
                    </div>
                  </div>
                  <div className={Styles.cardItrem}>
                    <div className={Styles.form}>
                      <label>Overtime</label>
                      <div className={classnames(Styles.otFiled, "form-group")}><Fields type='number' placeholder="" onChange={(e: any) => setOvertime(e.target.value)} value={overTime} disabled={sheetDetails && parseInt(sheetDetails.timesheet_status) > 1 && sheetDetails.submitted_on && sheetDetails.timesheet_status !== '4' ? true : false} /></div>
                    </div>
                  </div>
                  <div className={Styles.cardItrem}>
                    <div className={Styles.form}>
                      <label>Actual working hours:</label>
                      <span className={Styles.total}>{calcTotalworkingHours(data.filter(element => (element.dayStatus !== 'Weekend' && element.dayStatus !== 'Holiday' && element.dayStatus !== 'Full day leave' && element.dayStatus !== 'Compensation off')))}</span>
                    </div>
                  </div>
                </div>
                <Error>{error}</Error>
                <div className={Styles.totalaction}>
                  {sheetDetails && (!sheetDetails.submitted_on || sheetDetails.timesheet_status === '1') && <Button onClick={() => { saveChanges({}, 'save'); setName('save') }} type="submit" disabled={submitButton} variant="cancel">Save</Button>}
                  {sheetDetails && (!sheetDetails.submitted_on || sheetDetails.timesheet_status === '4' || sheetDetails.timesheet_status === '1') && <Button onClick={() => saveTimesheet()} type="submit" disabled={submitButton} variant="primary">Submit</Button>}
                </div>
                {showSubmitModal && <TimeSheetSubmit submitButton={modalSubmitButton} modalData={modalData} candidateData={candidateData} projectDetails={projectDetails} onClose={() => setShowSubmitModal(false)} onSubmit={(data: any) => saveChanges(data, name)} />}
                {notification && <NotificationAlert onClose={() => setNotification(false)} closable={true} >{message}</NotificationAlert>}
              </div>
            </div>
          </div>
          {value && value.timesheetHistory &&
            <div>
              <Headline5>Timesheet History</Headline5>
              <Table type='checkHistory' data={checkHistoryData} />
            </div>
          }
        </div>
      </section>
    </div>
  )
}

export default Avilability;

const companyName = (props: GridCellProps) => {
  return (
    <td>
      <div className="userInfo">
        {props.dataItem && props.dataItem.entryDate}
      </div>
    </td>
  )
}

const DropDown = (props: GridCellProps) => {

  const handleChange = (e: DropDownListChangeEvent) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.value.text,
      })
    }
  }

  return (
    <td>
      {props.dataItem.inEdit ? <DropDownList
        style={{ width: "100%" }}
        onChange={handleChange}
        value={finddayStatus(props.dataItem.dayStatus)}
        data={[
          { text: 'Holiday', id: 1 },
          { text: 'Working', id: 2 },
          { text: 'Half day leave', id: 3 },
          { text: 'Full day leave', id: 4 },
          { text: 'Compensation off', id: 5 },
          { text: 'Half day compensation off', id: 6 },
          { text: 'Weekend', id: 7 }
        ]}
        textField="text"
      /> : props.dataItem.dayStatus}
    </td>
  )
}

const finddayStatus = (value: any) => {
  switch (value) {
    case 'Holiday':
      return { text: 'Holiday', id: 1 }
    case 'Working':
      return { text: 'Working', id: 2 }
    case 'Half day leave':
      return { text: 'Half day leave', id: 3 }
    case 'Full day leave':
      return { text: 'Full day leave', id: 4 }
    case 'Compensation off':
      return { text: 'Compensation off', id: 5 }
    case 'Half day compensation off':
      return { text: 'Half day compensation off', id: 6 }
    case 'Weekend':
      return { text: 'Weekend', id: 7 }
  }
}
